// Интерфейсы для Swagger API
export interface IWorkType {
  id: number;
  description: string;
  created_at: string;
  updated_at: string;
}

export interface IStandardType {
  id: number;
  description: string;
  created_at: string;
  updated_at: string;
}

export interface IMarketBranchMinimal {
  mb_id: number;
  next_sector_id: number;
  mb_region: string;
  mb_code: string;
  mb_name: string;
  mb_region_id: number;
  work_type: IWorkType;
  standard_id: number;
  standard: IStandardType;
  value: number;
  user_id: number;
  created_at: string;
  updated_at: string | null;
}

export interface IBaseStandard {
  id: number;
  work_type_id: number;
  work_type: IWorkType;
  standard_id: number;
  standard: IStandardType;
  value: number;
  user_id: number;
  created_at: string;
  updated_at: string | null;
}

export interface IRegionStandard extends IBaseStandard {
  market_branch_id: number;
  market_branch: IMarketBranchMinimal;
  updated_at: string;
}

export interface ICountryStandard extends IBaseStandard {}

export interface IFederalStandard extends IBaseStandard {
  region_name: string;
}

export interface ISectorStandard extends IBaseStandard {
  sector_id: number;
}

export interface IRegionStandardsResponse {
  region_standards: IRegionStandard[];
}

export interface ISectorStandardsResponse {
  sector_standards: ISectorStandard[];
}

export interface IFederalStandardsResponse {
  federal_standards: IFederalStandard[];
}

export interface ICountryStandardsResponse {
  country_standards: ICountryStandard[];
}

export interface IStandardsResponse<T> {
  standards: T[];
}

export interface IMarketBranchResponse {
  market_branch_id: number;
  name: string;
}

export interface Region {
  name: string;
}

// Нормативы скорости участков
export interface IVehicleType {
  id: number;
  description: string;
  created_at: string;
  updated_at: string | null;
}

export interface ISectorSpeedStandard {
  id: number;
  sector_id: number;
  vehicle_type_id: number;
  vehicle_type: IVehicleType;
  value: number;
  created_at: string;
  updated_at: string | null;
}

export interface ISectorSpeedStandardsParams {
  limit?: number;
  offset?: number;
  id?: number[];
  sector_id?: number[];
  vehicle_type_id?: number[];
  value?: number[];
}

// Опция селекта «Средство передвижения»: отдельного справочника на бэкенде нет,
// список собирается из vehicle_type в самих нормативах
export interface IVehicleTypeOption {
  id: number;
  name: string;
}

export interface IUpdateSectorSpeedStandardPayload {
  entity_id: number;
  value: number;
}

// Строка таблицы нормативов скорости с состоянием редактирования
export interface ISpeedNormativeRow {
  id: number;
  sectorId: number;
  vehicleTypeName: string;
  value: number | null;
  originalValue: number | null;
  isEditing: boolean;
  isSaving: boolean;
}

export const NORMATIVES_PATHS = {
  normatives: 'normatives',
  work_standards: 'work',
  speed_standards: 'speed',
};

export interface INormativeCell {
  value: number | null;
  id: number;
  standardId: number; // ID стандарта для идентификации
  isEditing: boolean;
  originalValue: number | null;
  isChanged: boolean;
}

export interface INormativeRow {
  workTypeName: string;
  cells: (INormativeCell | null)[];
  total: number;
}

export interface IUpdateStandardPayload {
  entity_id: number;
  value: number;
  user_id: number;
  cascade?: boolean;
}

export interface IUpdateResponse {
  status: string;
  message: string;
}

export interface INormativeView {
  id: number;
  name: string;
  driveToCDC: number;
  driveToClient: number;
  technical: number;
  documents: number;
  driveToCDCBack: number;
  total: number;
  regionId: number;
  branchId: number;
  sectorId: number | null;
}
